<template>
    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 24">
        <defs>
            <path
                id="weuiArrowOutlined0"
                fill="currentColor"
                d="m7.588 12.43l-1.061 1.06L.748 7.713a.996.996 0 0 1 0-1.413L6.527.52l1.06 1.06l-5.424 5.425z"
            />
        </defs>
        <use
            fill-rule="evenodd"
            href="#weuiArrowOutlined0"
            transform="rotate(-180 5.02 9.505)"
        />
    </svg> -->
    <svg
        viewBox="0 0 15 15"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M13.5319 7.74154L7.74128 13.5322C7.60809 13.6653 7.39191 13.6653 7.25872 13.5322C7.12554 13.399 7.12554 13.1828 7.25872 13.0496L12.4668 7.84155L1.70938 7.84143C1.52095 7.84143 1.36822 7.6887 1.36822 7.50027C1.36822 7.40593 1.40634 7.32076 1.46811 7.25899C1.52987 7.19722 1.61516 7.15898 1.70938 7.1591L12.4669 7.1591L7.25872 1.95092C7.12554 1.81774 7.12554 1.60156 7.25872 1.46837C7.39191 1.33519 7.60809 1.33519 7.74128 1.46837L13.5319 7.25899C13.6651 7.39218 13.6651 7.60836 13.5319 7.74154Z"
            fill="currentColor"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.4668 7.84148L7.25872 13.0495C7.12554 13.1827 7.12554 13.3989 7.25872 13.5321C7.39191 13.6653 7.60809 13.6653 7.74128 13.5321L13.5319 7.74147C13.5568 7.71653 13.5771 7.68869 13.5927 7.65903C13.6024 7.64047 13.6104 7.62121 13.6165 7.6015C13.6369 7.53562 13.6369 7.46476 13.6165 7.39888C13.6104 7.37922 13.6025 7.36 13.5928 7.34149C13.5772 7.31178 13.5569 7.28389 13.5319 7.25892L7.74128 1.4683C7.60809 1.33511 7.39191 1.33511 7.25872 1.4683C7.12554 1.60148 7.12554 1.81766 7.25872 1.95085L12.4669 7.15903L1.70938 7.15903C1.61516 7.15891 1.52987 7.19715 1.46811 7.25892C1.40634 7.32068 1.36822 7.40585 1.36822 7.50019C1.36822 7.68863 1.52095 7.84136 1.70938 7.84136L12.4668 7.84148ZM11.2597 8.34146L6.90517 12.696C6.57672 13.0244 6.57672 13.5572 6.90517 13.8856C7.23362 14.2141 7.76638 14.2141 8.09483 13.8856L13.8854 8.09502C14.2139 7.76657 14.2139 7.23381 13.8854 6.90536L8.09483 1.11474C7.76638 0.786297 7.23362 0.786297 6.90517 1.11474C6.57672 1.44319 6.57672 1.97596 6.90517 2.3044L11.2598 6.65903L1.71002 6.65903C1.70989 6.65903 1.71016 6.65903 1.71002 6.65903C1.47734 6.65884 1.26598 6.75393 1.11455 6.90536C0.962763 7.05715 0.868217 7.26804 0.868217 7.50019C0.868217 7.96477 1.2448 8.34136 1.70938 8.34136L11.2597 8.34146Z"
            fill="currentColor"
        />
    </svg>
</template>
